import { User } from 'types/user';

export const initialState: UserManagementState = {
  user: undefined,
  barcode: '',
  errorMessage: '',
  deleteErrorMessage: '',
  isProcessing: false,
  isLoadingUser: false,
  isLoadingUsersList: false,
  passwordResetSuccess: false,
  passwordResetErrorMessage: '',
  requestSuccess: undefined
};

export interface UserManagementState {
  user?: User;
  barcode: string;
  errorMessage: string;
  deleteErrorMessage: string;
  isProcessing: boolean;
  isLoadingUser: boolean;
  isLoadingUsersList: boolean;
  passwordResetSuccess: boolean;
  passwordResetErrorMessage: string;
  requestSuccess?: boolean;
}


// WEBPACK FOOTER //
// ./src/pages/user-management/state.ts